import Vue from 'vue'
import utility from './../utility/vue-common'
import tagularModule from 'js/store/helpers/tagular'

var showButton = document.querySelector('[data-social-share-show]')
var closeButton = document.querySelector('[data-social-share-close]')
var socialContainer = document.querySelector('[data-social-share-container]')
var socialBloomContainer = document.querySelector('[data-social-share]')
var strWindowFeatures =
  'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=500,height=500,top=0'
var button
var currentURL
var metaDescription
var title
var link

var mixin = {
  methods: {
    getPageURL: function() {
      return encodeURI(
        window.location.host + window.location.pathname + window.location.search
      )
    },
    getTitle: function() {
      return encodeURI(window.document.title.replace('| Bankrate.com', ''))
    },
    getMeta: function(name, content) {
      content = content === null ? 'content' : content
      var metaElm = document.querySelector("meta[name='" + name + "']")
      return (metaElm && metaElm.getAttribute(content)) || ''
    },
    prep: function(event) {
      button = this.closest(event.target, function(el) {
        return el.dataset && el.dataset.shareButton
      })

      currentURL = this.getPageURL()
      title = this.getTitle()
      link = (button && button.getAttribute('href')) || ''
      link = decodeURI(link)

      link = link.replace('[URL]', currentURL)
      link = link.replace('[TITLE]', title)
      link = link.replace('[SOURCE]', window.location.host)
      link = link.replace('[MEDIA]', this.getMeta('twitter:image', 'content'))
      
      if (document.querySelector('[data-pull-quote-copy]')) {
        let quote = document.querySelector('[data-pull-quote-copy]').innerHTML
        link = link.replace('[QUOTE]', quote)
      }
    },
    sharePage: function(event) {
      event.preventDefault()
 
      this.prep(event)

      var button = this.closest(event.target, function(el) {
        return el.dataset && el.dataset.shareButton
      })

      var windowProps =
        button &&
        button.dataset &&
        button.dataset.newWindow &&
        button.dataset.newWindow === 'false'
          ? null
          : strWindowFeatures

      var shareWindow = window.open(link, 'Share', windowProps)

      let socialMediaType = button.dataset.socialType

      try {
        shareWindow.focus()
      } catch (error) {
        window.location = link
      }

      this.trackClickEvent(socialMediaType)
    },
    emailPage: function(event) {
      event.preventDefault()

      metaDescription = this.getMeta('description', 'content')
      currentURL = this.getPageURL()
      title = this.getTitle()

      window.location =
        'mailto:?subject=' +
        title +
        '&body=' +
        metaDescription +
        '%0D%0A' +
        '%0D%0A' +
        currentURL

      let socialMediaType = 'email'

      this.trackClickEvent(socialMediaType)
    },
    trackClickEvent: function(socialMediaType) {
      const webElement = {
        location: 'Article Pages',
        position: 'left sidebar',
        elementType: 'icon',
        text: socialMediaType,
        htmlId: 'social-share'
      }

      const actionOutcome = 'social sharing'
      const outboundUrl = ''
      const correlationId = ''

      tagularModule.elementClicked(
        webElement,
        actionOutcome,
        outboundUrl,
        correlationId,
        'redventures.usertracking.v3.ElementClicked'
      )

      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({
        dL_navHeading: socialMediaType,
        dL_position: 'left sidebar',
        event: 'e_navSocial'
      })
    },
    more: function(event) {
      event.preventDefault()

      button = this.closest(event.target, function(el) {
        return /social-share__button/.test(el.className)
      })

      // Toggle switch
      if (/--less/.test(button.className)) {
        button.className = button.className.replace('--less', '')
      } else {
        button.className += ' --less'
      }

      // Toggle SVG
      var svg = button.querySelector('use')

      if (svg) {
        if (/open-icon/.test(svg.getAttribute('xlink:href'))) {
          svg.setAttribute(
            'xlink:href',
            baseUrl + '/content/svg/sprite.svg#minus'
          )
        } else {
          svg.setAttribute(
            'xlink:href',
            baseUrl + '/content/svg/sprite.svg#open-icon'
          )
        }
      }
    },
    toggleSocialItems: function() {
      this.isBloomOpen = !this.isBloomOpen

      // Toggle SVG
      var svg = document.querySelector('[data-toggle-icon] > use')

      if (svg) {
        if (this.isBloomOpen) {
          svg.setAttribute(
            'xlink:href',
            baseUrl + '/content/svg/sprite.svg#close'
          )
        } else {
          svg.setAttribute(
            'xlink:href',
            baseUrl + '/content/svg/sprite.svg#share'
          )
        }
      }
    },
    showSocial: function(e) {
      e.preventDefault()

      showButton.addEventListener(
        'click',
        showSocialContainer(socialContainer),
        false
      )

      function showSocialContainer(el) {
        if (el.classList.contains('--hide')) {
          el.classList.remove('--hide')
        }
      }
    },
    hideSocial: function(e) {
      e.preventDefault()

      closeButton.addEventListener(
        'click',
        closeSocialContainer(socialContainer),
        false
      )

      function closeSocialContainer(el) {
        if (!el.classList.contains('--hide')) {
          el.classList.add('--hide')
        }
      }
    }
  }
}

var vueInstance = []
var elms = [].slice.call(document.querySelectorAll('[data-social-share]'))

elms.forEach(function(el) {
  vueInstance.push(
    new Vue({
      el: el,
      props: {
        isBloomOpen: false
      },
      mixins: [
        mixin, 
        utility
      ]
    })
  )
})
